import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type GuestOrderPayload, initialState } from "../../types/guestOrder";
import { type RootState } from "../root/config.store";

// Post Slice
export const guestOrderSlice = createSlice({
  name: "guestOrder",
  initialState,
  reducers: {
    submitGuestOrder(state, action: PayloadAction<GuestOrderPayload>) {
      state.data = action.payload;
      state.success = false;
      state.loading = true;
      state.error = null;
    },
    submitGuestOrderSuccess(state, action: PayloadAction<GuestOrderPayload>) {
      state.data = action.payload;
      state.error = null;
      state.loading = false;
      state.success = true;
    },
    submitGuestOrderFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    saveFormData(state, action: PayloadAction<GuestOrderPayload>) {
      state.data = action.payload;
    },
    resetGuestOrderState(state) {
      state.success = false;
      state.error = null;
      state.loading = false;
    },
  },
});

// Actions
export const guestOrderActions = {
  submitGuestOrderStart: guestOrderSlice.actions.submitGuestOrder,
  submitGuestOrderSuccess: guestOrderSlice.actions.submitGuestOrderSuccess,
  submitGuestOrderFailure: guestOrderSlice.actions.submitGuestOrderFailure,
  saveFormData: guestOrderSlice.actions.saveFormData,
  resetGuestOrderState: guestOrderSlice.actions.resetGuestOrderState,
};

// Selectors
export const selectGuestOrder = (state: RootState): GuestOrderPayload =>
  state.guestOrder?.data;

// Reducer
export default guestOrderSlice.reducer;
